import React from "react";
import { Header } from "semantic-ui-react";

import "./style.css";

const Write = () => {
    return (
        <>
            <Header as="h1" id="write-header">Write</Header>
        </>
    );
};

export default Write;